import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import '../../assets/css/component/DataTable.css'

class DataTable extends Component {
    constructor(props) {
        super(props);
        this.gridRef = React.createRef();
        this.state = {
            pageSize: 10
        };
    }

    defaultColDef = {
        flex: 1,
        resizable: true,
    };

    paginationNumberFormatter = (params) => {
        return params.value.toLocaleString();
    };

    onFirstDataRendered = (params) => {
        this.gridRef.current.api.sizeColumnsToFit();
    };

    onPageSizeChanged = () => {
        const value = document.getElementById('page-size').value;
        this.gridRef.current.api.paginationSetPageSize(Number(value));
        this.setState({ pageSize: Number(value) });
    };

    onFilterTextBoxChanged = () => {
        this.gridRef.current.api.setGridOption(
        "quickFilterText",  document.getElementById("filter-text-box").value
        );
      };
    onBtnExport = () => {
        this.gridRef.current.api.exportDataAsCsv();
    };

    onSelectionChanged = (params) => {
        const selectedData = this.gridRef.current.api.getSelectedRows();
        this.props.value(this.props.field, selectedData);
    };
  

    render() {
        return (
            <>
                <div className="d-flex justify-content-between align-items-center">
                    <div className='data-table-extensions-filter'>
                        <input
                            type="text"
                            id="filter-text-box"
                            placeholder="Search"
                            onInput={this.onFilterTextBoxChanged}
                            className="form-control form_input"
                        />
                    </div>
                    <div className="d-flex align-items-center">
                        <label htmlFor="" className="form-label form_label" style={{ marginBottom: 0 }}>Page Size</label>
                        <select
                            className="form-select form_input ms-2"
                            onChange={this.onPageSizeChanged}
                            id="page-size"
                            style={{ width: '12vh' }}
                            value={this.state.pageSize}
                        >
                            <option value="10">10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                        </select>
                        {/* <FaDownload size={25} onClick={this.onBtnExport} className='ms-4 me-2' style={{ cursor: 'pointer', color: '#56ab2f' }} /> */}
                    </div>
                </div>
                <div
                    className="ag-theme-alpine mt-2"
                    style={{ height: this.props.height || '60vh', width: '100%' }}
                >
                    <AgGridReact
                        ref={this.gridRef}
                        rowData={this.props.rowData || []}
                        columnDefs={this.props.columnDefs || []}
                        defaultColDef={this.defaultColDef}
                        pagination={true}
                        paginationPageSize={this.state.pageSize}
                        paginationNumberFormatter={this.paginationNumberFormatter}
                        onFirstDataRendered={this.onFirstDataRendered}
                        rowHeight={this.props.rowHeight || 40}
                        rowSelection={this.props.check ? 'multiple' : null}
                        suppressRowClickSelection={this.props.selection ? true : false}
                        onSelectionChanged={this.props.selection ? this.onSelectionChanged : null}
                        // {...this.props.gridOptions}
                    />
                </div>
            </>
        );
    }
}

export default DataTable;
